var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppLayoutBase',[_c('template',{slot:"main"},[_c('AuthForgotPasswordContent')],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }